import { createActionGroup } from '@ngrx/store';

export const SocieteTerritoireUserActions = createActionGroup({
  source: 'Societe Territoire User',
  events: {}
});
